import { initializeApp } from 'firebase/app';
import {
	collection,
	doc,
	getFirestore,
	onSnapshot,
	query,
	updateDoc,
	where,
} from '@firebase/firestore';
import { FirebaseData } from '../types';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const ENV = process.env.REACT_APP_FIREBASE_APP_ENV || 'dev';

export function fetchChatNumbers(
	onSuccessCallback: (data: Array<FirebaseData>) => void,
) {
	const chatListRef = collection(doc(db, 'bot', ENV), 'chatList');
	const unsubscribe = onSnapshot(chatListRef, snapshot => {
		const newData: FirebaseData[] = snapshot.docs.map(doc => ({
			id: doc.id,
			...doc.data(),
		})) as FirebaseData[];

		onSuccessCallback(newData);
	});

	return unsubscribe;
}

export function fetchChats(
	phoneNumber: string,
	onSuccessCallback: (data: Array<FirebaseData>) => void,
) {
	const chatHistoryRef = collection(doc(db, 'bot', ENV), 'chatHistory');
	const filterQuery = query(
		chatHistoryRef,
		where('phoneNumber', '==', phoneNumber),
	);

	const unsubscribe = onSnapshot(filterQuery, snapshot => {
		const newData: FirebaseData[] = snapshot.docs.map(doc => ({
			id: doc.id,
			...doc.data(),
		})) as FirebaseData[];

		onSuccessCallback(newData);
	});

	return unsubscribe;
}

export function resetMessageReadCount(phoneNumber: string) {
	const numberRef = doc(db, 'bot', ENV, 'chatList', phoneNumber);
	updateDoc(numberRef, {
		unread_count: 0,
	});
}
